import React from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import { Form } from 'semantic-ui-react';
import { ATTRIBUTE_TYPE, ATTRIBUTE_TYPE_INPUT_TYPE_MAPPING } from '../../../../HelperMethods/FormUtils';
import { getPriorityList, getPriorityTemplateSpecs } from '../../../../HelperMethods/TaskUtilities';
import { parseJSONStringToObject } from '../../../../HelperMethods/UtilityFunctions';

const GetPriorityOptions = (taskType, task, taskList) => {
  let priorityTemplate = _.get(taskType, 'priorityTemplate');
  let priorityAlias = _.get(taskType, 'priorityAlias');
  if (_.get(task, 'parentTaskId')) {
    const reqParentTask = taskList.find((t) => t.id === task.parentTaskId);

    priorityTemplate = _.get(reqParentTask, 'taskType.priorityTemplate');
    priorityAlias = _.get(reqParentTask, 'taskType.priorityAlias');
  }

  const { basePriority, maxPriority } = getPriorityTemplateSpecs(priorityTemplate);

  const priorityListOptions = getPriorityList(basePriority, maxPriority, priorityAlias);

  return { priorityListOptions, priorityTemplate: `${basePriority}-${maxPriority}` };
};

const PriorityForTaskBulkEdit = (props) => {
  const { attributeObj, formik, selectedTasks } = props;
  const taskList = useSelector((state) => state.taskViewPageReducer.tasks.items);

  const priorityVal = _.get(formik.values, attributeObj.attributeName);
  const attributeOnChange = (event, data) => {
    if (_.isEmpty(data.value)) {
      formik.setFieldValue(attributeObj.attributeName, null);
    } else {
      formik.setFieldValue(attributeObj.attributeName, data.value);
    }
  };
  const [priorityListOptions, setpriorityListOptions] = React.useState([]);
  let priorityListOptionstemp = {};
  const priorityTemplate = [];
  let priorityAlias = {};
  const [disablePriority, setdisablePriority] = React.useState(false);
  // number of options are same and each option is similar.
  React.useEffect(() => {
    if (selectedTasks) {
      selectedTasks.every((e) => {
        const taskType = _.get(e, 'taskType', {});
        // eslint-disable-next-line no-unused-vars
        priorityListOptionstemp = GetPriorityOptions(taskType, e, taskList);
        if (
          !_.isEmpty(priorityTemplate) &&
          !priorityTemplate.includes(_.get(priorityListOptionstemp, 'priorityTemplate'))
        ) {
          setdisablePriority(true);
          setpriorityListOptions([]);
          return false;
        }
        if (!disablePriority) {
          priorityTemplate.push(_.get(priorityListOptionstemp, 'priorityTemplate'));
          setpriorityListOptions(_.get(priorityListOptionstemp, 'priorityListOptions'));
          priorityAlias = parseJSONStringToObject(_.get(taskType, 'priorityAlias'));
        }
        return true;
      });
    }
  }, []);

  return (
    <Form.Field>
      <>
        <label>
          {_.get(priorityAlias, 'name') ? `Priority (${_.get(priorityAlias, 'name')})` : 'Priority'}
          {attributeObj.isMandatory ? <span className="mandatory-field">*</span> : null}
        </label>
        {ATTRIBUTE_TYPE_INPUT_TYPE_MAPPING[ATTRIBUTE_TYPE.PICKLIST]({
          name: attributeObj.attributeName,
          value: priorityVal,
          options: priorityListOptions,
          placeholder: attributeObj.displayName || attributeObj.name,
          onChange: attributeOnChange,
          multiple: attributeObj.multiple,
          disabled: disablePriority,
        })}
      </>
    </Form.Field>
  );
};

export default PriorityForTaskBulkEdit;
